const AdminDefaultIcons = {
     "EDIT": require(`../../assets/images/admin-portal/edit-icon.svg`).default,
     "DELETE": require(`../../assets/images/admin-portal/delete-icon.svg`).default,
     "ACCESS_REVOKE": require(`../../assets/images/admin-portal/edit-user-role-img.png`).default
}

 
 export default AdminDefaultIcons;